import { isArrayEmpty } from 'util/isArrayEmpty';

import {
  ClassificationDto,
  ClassificationModel,
  mapClassificationDtoToModel,
  mapClassificationModelToDto,
} from 'api/dto/Classification.dto';

export enum DemographicKind {
  Choice = 0,
  Date = 1,
}

export type DemographicDto = {
  id?: number;
  title?: string;
  reportedAs?: string;
  position?: number;
  kind?: DemographicKind;
  classifications?: ClassificationDto[];
};

export type DemographicModel = {
  id?: number;
  title?: string;
  reportedAs?: string;
  position?: number;
  kind?: DemographicKind;
  classifications?: ClassificationModel[];
};

export function mapDemographicModelToDto(model: DemographicModel): DemographicDto {
  return {
    title: model.title,
    position: model.position,
    reportedAs: model.reportedAs,
    classifications: !isArrayEmpty(model.classifications)
      ? model.classifications
          .map(mapClassificationModelToDto)
          .sort((a, b) => a.position - b.position)
      : undefined,
  };
}

export function mapDemographicDtoToModel(dto: DemographicDto): DemographicModel {
  return {
    id: dto.id,
    title: dto.title,
    reportedAs: dto.reportedAs,
    position: dto.position,
    kind: dto.kind,
    classifications: (dto.classifications || [])
      .filter((classificationEntry) => !!classificationEntry)
      .map((classificationEntry) => mapClassificationDtoToModel(classificationEntry)),
  };
}
